import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c10479fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 2,
  id: "app-environment"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BToaster = _resolveComponent("BToaster")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BToaster, {
      name: "router-link-toaster",
      class: "router-link-toaster"
    }),
    _createTextVNode(),
    (_ctx.debug)
      ? (_openBlock(), _createBlock(_component_BButton, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Debug' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n      デバッグメニュへ\n    ")
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.debug)
      ? (_openBlock(), _createBlock(_component_BButton, {
          key: 1,
          to: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n      戻る\n    ")
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("div", null, [
      _createVNode(_component_RouterView)
    ]),
    _createTextVNode(),
    (!!_ctx.environment && _ctx.environment !== 'prod')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.environment), 1))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (!!_ctx.environment && _ctx.environment !== 'prod')
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          id: "app-product",
          class: _normalizeClass([`product-${_ctx.product.slug}`])
        }, _toDisplayString(_ctx.product.name), 3))
      : _createCommentVNode("", true)
  ]))
}